import styled from 'styled-components'

const ConversationItemMetadata = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	white-space: nowrap;
	width: 100%;
`

export default ConversationItemMetadata